import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import './index.css';
// import './reactStyles.css';
import CatalogIndex from './CatalogProgramPage';
import * as serviceWorker from './serviceWorker';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<CatalogIndex />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
